import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/search.tsx';
defineClientComponent('search', Component);